/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getOrganAtRisks } from 'app/entities/organ-at-risk/organ-at-risk.reducer';
import { getEntities as getTreatmentRadiations } from 'app/entities/treatment-radiation/treatment-radiation.reducer';
import { createEntity, getEntity, reset, updateEntity } from './treatment-organ-at-risk.reducer';

export const TreatmentOrganAtRiskUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const organAtRisks = useAppSelector(state => state.organAtRisk.entities);
  const treatmentRadiations = useAppSelector(state => state.treatmentRadiation.entities);
  const treatmentOrganAtRiskEntity = useAppSelector(state => state.treatmentOrganAtRisk.entity);
  const loading = useAppSelector(state => state.treatmentOrganAtRisk.loading);
  const updating = useAppSelector(state => state.treatmentOrganAtRisk.updating);
  const updateSuccess = useAppSelector(state => state.treatmentOrganAtRisk.updateSuccess);

  const handleClose = () => {
    navigate(`/treatment-organ-at-risk${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getOrganAtRisks({}));
    dispatch(getTreatmentRadiations({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...treatmentOrganAtRiskEntity,
      ...values,
      organ: organAtRisks.find(it => it.id.toString() === values.organ?.toString()),
      radiationSession: treatmentRadiations.find(it => it.id.toString() === values.radiationSession?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...treatmentOrganAtRiskEntity,
          organ: treatmentOrganAtRiskEntity?.organ?.id,
          radiationSession: treatmentOrganAtRiskEntity?.radiationSession?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.treatmentOrganAtRisk.home.createOrEditLabel" data-cy="TreatmentOrganAtRiskCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.treatmentOrganAtRisk.home.createOrEditLabel">
              Create or edit a TreatmentOrganAtRisk
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="treatment-organ-at-risk-id"
                  label={translate('tinyMedicRestApp.treatmentOrganAtRisk.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentOrganAtRisk.exposureDose')}
                id="treatment-organ-at-risk-exposureDose"
                name="exposureDose"
                data-cy="exposureDose"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentOrganAtRisk.exposureDoseUnit')}
                id="treatment-organ-at-risk-exposureDoseUnit"
                name="exposureDoseUnit"
                data-cy="exposureDoseUnit"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentOrganAtRisk.active')}
                id="treatment-organ-at-risk-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentOrganAtRisk.cursor')}
                id="treatment-organ-at-risk-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentOrganAtRisk.lastUpdated')}
                id="treatment-organ-at-risk-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentOrganAtRisk.microSec')}
                id="treatment-organ-at-risk-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentOrganAtRisk.timestampEntry')}
                id="treatment-organ-at-risk-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="treatment-organ-at-risk-organ"
                name="organ"
                data-cy="organ"
                label={translate('tinyMedicRestApp.treatmentOrganAtRisk.organ')}
                type="select"
              >
                <option value="" key="0" />
                {organAtRisks
                  ? organAtRisks.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="treatment-organ-at-risk-radiationSession"
                name="radiationSession"
                data-cy="radiationSession"
                label={translate('tinyMedicRestApp.treatmentOrganAtRisk.radiationSession')}
                type="select"
              >
                <option value="" key="0" />
                {treatmentRadiations
                  ? treatmentRadiations.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/treatment-organ-at-risk" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TreatmentOrganAtRiskUpdate;
